import {
    IBaseItem,
    INewsResponse,
    IResponseItem,
    IResponseItemTag,
} from '@r1-frontend/api-domru/content-static/v2/news/dto/responseDto';

export interface INewsFormatted {
    items: IResponseItem[],
    pageCount: number,
    currentPage: number,
    perPage: number,
}

export const getFormattedNews = (data: INewsResponse): INewsFormatted => {
    const {
        items,
        _meta: {
            pageCount,
            currentPage,
            perPage: perPageCount,
        },
    } = data;

    const preparedItems = items.map((baseItem: IBaseItem): IResponseItem => {
        const { newsTitle, newsImage, newsAlias, newsDescription, activeFrom, categoriesInfo, host, pinned } = baseItem;

        const preparedTags: IResponseItemTag[] = categoriesInfo.map(({ name, alias, contentId }) => {
            return { title: name, alias, contentId, name };
        });

        return ({
            alias: newsAlias,
            title: newsTitle,
            text: newsDescription,
            image: newsImage,
            active_from: activeFrom,
            tags: preparedTags,
            pinned,
            host,
        });
    });

    return {
        items: preparedItems,
        pageCount,
        currentPage,
        perPage: perPageCount,
    };
};
